import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/contact-us-thank-you")({
  beforeLoad: () => {
    throw redirect({ to: "/contact", statusCode: 301 });
  },
});
